import {
  BookOpen,
  Landmark,
  Heart,
  Lock,
  MapPin,
  FileText,
  Leaf,
  Sprout,
  Wheat,
  Package,
  Spool,
  Factory,
  Droplet,
  Sun,
  Fuel,
  Wrench,
  Newspaper,
  Image,
  Video,
  Tractor,
  Library,
  Mic,
  CalendarDays,
  MessageCircle,
  Briefcase,
  ShieldAlert,
  ShieldCheck,
  Circle,
} from 'lucide-react';

// Ícone é escolhido pelo título do item (normalizado), já que a CMS ainda não
// tem um campo de ícone -- itens sem título mapeado aqui caem no ícone padrão.
const ICONS_BY_TITLE = {
  'nossa história': BookOpen,
  'governança': Landmark,
  'cultura copasul': Heart,
  'memórias do sr. sakae': Lock,
  'nossas unidades': MapPin,
  'relatórios oficiais': FileText,
  'sustentabilidade': Leaf,
  'construindo solos': Sprout,
  'comercial de grãos': Wheat,
  'insumos': Package,
  'fiação': Spool,
  'fecularia': Factory,
  'irrigação': Droplet,
  // Ainda não existe no layoutmenu do Squidex; mapeado para quando o item for
  // criado lá (rota /energiaSolar), senão cairia no ícone padrão.
  'energia solar': Sun,
  'trr copasul': Fuel,
  'assistência técnica': Wrench,
  'notícias': Newspaper,
  'galeria de fotos': Image,
  'vídeos': Video,
  'copasul rural': Tractor,
  'revistas copasul': Library,
  'sala de imprensa': Mic,
  'entrevistas & eventos': CalendarDays,
  'fale conosco': MessageCircle,
  'trabalhe conosco': Briefcase,
  'canal de denúncias': ShieldAlert,
  'política de privacidade': ShieldCheck,
};

export const DEFAULT_MENU_ICON = Circle;

export const getMenuIcon = (title) => {
  const key = (title || '').trim().toLowerCase();
  return ICONS_BY_TITLE[key] || DEFAULT_MENU_ICON;
};
